import React, { Component } from "react";
// import Wrp from '../../../../../../../hoc/Wrp/Wrp';
import BootstrapRow from '../../../../../../../hoc/BootstrapRow';
import BootstrapColumn from '../../../../../../../hoc/BootstrapColumn';
import {callGET} from '../../../../../../../Utils/ApiUtil';
import Autocomplete from '../../../../../../AutoComplete';
import ReactTags from '../../../../../../ReactTags';
import FormInputFields from '../../../../../../FormInputFields';
import {isSet} from '../../../../../../../Utils/CommonFunctions';
import {getUserInfo} from '../../../../../../../Utils/UserFunctions';
import ToolTipWrapper from '../../../../../../../hoc/Wrp/ToolTipWrapper';
// import reminder from "../../../../../../Icons/IconsList/IconReminder";

const KeyCodes = {
  comma: 188,
  enter: 13,
};
let delimiters = [KeyCodes.comma, KeyCodes.enter];

class EmailOptions extends Component{
  constructor(props) {
    super(props);
    this.state = {
      emailConfigList:[],
      emailTemplateList:[],
      autoTemplateSearch:'',
      selectedTemplate:'',
      userListDataArr:[],
      userSelectedList:[]
    }
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
  }

    componentDidMount = async ()=>{
        this.fetchEmailConfigList();
        this.fetchEmailTemplateList('');
        this.fetchUserList('');
        //console.log('componentDidMount=',this.state.userSelectedList)
        const userInfo = getUserInfo();
          let displayName = [];
          displayName.push(userInfo.data.first_name+'' +userInfo.data.last_name);
          // await this.setState({
          //   userSelectedList:[...this.state.userSelectedList, {
          //       text:userInfo.data.first_name+' '+userInfo.data.last_name,
          //       label:userInfo.data.first_name+' '+userInfo.data.last_name,
          //       id:userInfo.data.id,
          //       value:userInfo.data.id
          //     }]
          // });
          // setTimeout(() => {
          //    this.updateUserSelectedValues();
          //   this.updateNotifyUsers();
          //   }, 500);

          //this.updateUserSelectedValues();
            this.updateNotifyUsers();
          
    }
    componentDidUpdate = (prevProps,prevState)=>{
      if(prevProps.reminderJson.email_template_id!==this.props.reminderJson.email_template_id || prevState.emailTemplateList!==this.state.emailTemplateList){
        this.updateSelectedValues();
      }
      if(prevProps.reminderJson.notified_users!==this.props.reminderJson.notified_users){
        //console.log('componentDidUpdate === ')
        //this.updateUserSelectedValues();
      }
    }
    updateUserSelectedValues = ()=>{
      //console.log('updateUserSelectedValues==',this.props.reminderJson.notified_users,this.state.userListDataArr)
      let updateUserSelectedList = [];
        let isExist = 0;
        isSet(this.props.reminderJson.notified_users,[]).map((itm)=>{
          if(itm.label){
            isExist++;
            updateUserSelectedList.push({
              ...itm,
              id:itm.value,
              text:itm.label
            })
          }else{
            
            isSet(this.state.userListDataArr,[]).map((userlist)=>{                
              if(itm.value === userlist.id){
                isExist++;
                //console.log('checkVal==',userlist)
                updateUserSelectedList.push(userlist)
              } 
              
            })
            //updateUserSelectedList = this.state.userListDataArr;
          }
        })
        if(isExist>0){
          //console.log('isExist==',isExist)
          this.setState({userSelectedList:updateUserSelectedList});
          this.updateNotifyUsers();
        }
    }
    updateSelectedValues = ()=>{
      const {actionChangeHandler,reminderJson} = this.props;
      const {emailTemplateList} = this.state;
      const {email_template_id} = reminderJson;
      emailTemplateList.map((item)=>{
          if(item.value===email_template_id){
            this.setState({selectedTemplate:item.label});
          }
      })
    }
    
    render(){
      const {actionChangeHandler,reminderJson} = this.props;
      const {email_config_id,email_template_id} = reminderJson;
        const emailConfig = {
          type:'PickList',
          label:{
            text:"Email Configuration",
            className:"",
          },
          isDefault:true,
          attributes:{
          },
          validation:{
            required:true,
            isValid:false
          },
          value:email_config_id,
          changeHandler:(val)=>actionChangeHandler({},'email_config_id',val),
          options:this.state.emailConfigList
        }
        console.log('this.state.selectedTemplate',this.state.selectedTemplate)
        return(
          <BootstrapRow>
            <BootstrapColumn column='col-6'>
              <div className="form-group mb-0">
                <label className="text-truncate mb-0">Email Configuration</label>
                <FormInputFields {...emailConfig} />
              </div>
            </BootstrapColumn>
            <BootstrapColumn column='col-6'>
              <div className="form-group mb-0">
                <label className="text-truncate mb-0">Email template</label>
                <div className="input-group autocomplete">
                  <input 
                    type="hidden"
                    value={''}
                  />
                  <Autocomplete
                      attributes={{className:'form-control'}}
                      suggestions={this.state.emailTemplateList}
                      search={this.autoCompleteSearch}
                      select={this.autoCompleteSelect}
                      isRequired={true}
                      {...this.props}
                      selectedValue={this.state.selectedTemplate} 
                    />
                  </div>
              </div>
            </BootstrapColumn>
            <BootstrapColumn column="col-12">
              <div className="form-group mt-2">
                <label className="text-truncate mb-0">Notify Users</label>
                <div className="input-group autocomplete">
                  <ReactTags
                    tags={this.state.userSelectedList}
                    placeHolder={'Search here..'}
                    suggestions={
                        (this.state.userListDataArr)?
                        this.state.userListDataArr:[]
                    }
                    delimiters={delimiters}
                    handleDelete={this.handleDelete}
                    handleAddition={this.handleAddition}
                    handleDrag={this.handleDrag}
                    handleInputChange={this.handleInputChange}
                    handleTagClick={this.handleTagClick}
                />
                </div>
              </div>
            </BootstrapColumn>
          </BootstrapRow>
        )
    }

  fetchUserList =(value) =>{
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    const perPage = 10;//pagination.perPage; 
    const direction = 'ASC';//pagination.direction; 
    const search = value;
    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    callGET('users/fetch-users/active'+queryString)
    .then(res => {
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){
          let updateTableData = [];
          this.setState({lookup_layout:{
            moduleId:response.data.module_id,
            windowId:response.data.window_id,
            windowName:this.props.item.value
          }});
          response.data.content.map((item)=>{
            updateTableData.push({
              label:item.first_name+' '+item.last_name,
              value:item.id,
              id:item.id,
              text:item.first_name+' '+item.last_name
            });
        })
        // console.log(updateTableData);
        this.setState({userListDataArr:[...updateTableData]});
        this.updateUserSelectedValues();
        }else{
          this.setState({userListDataArr:[]});
          this.updateUserSelectedValues();
        }
      }
    })
  }
  
     // DELETE/CANCEL ADDED LOOKUP VALUES
     handleDelete(i) {
      console.log(i);
      if(i!==-1){
          // this.setState({ 
          //   userSelectedList:[
          //     ...this.state.userSelectedList.filter((tag, index) =>{
          //         if(index !== i){
          //             return tag;
          //         }
          //     }),
          //   ]
          // });

          let userSelectedListArr = this.state.userSelectedList;
          userSelectedListArr = this.state.userSelectedList.filter((tag, index) =>{
              if(index !== i){
                  return tag;
              }
          })
          this.setState({
              userSelectedList:userSelectedListArr
          });

          //console.log(userSelectedListArr,'userSelectedListArr===')
          setTimeout(() => {
            this.updateNotifyUsers();
          }, 1000);
          
      }
    }
    //ADD WHEN SELECT FROM SUGGESTION
    handleAddition = async (tag)=> {
        if(tag.value===undefined){
        }else{
           //  console.log('userSelectedList handleAddition',tag);
           // await this.setState({
           //    userSelectedList:[...this.state.userSelectedList, tag]
           //  });

           let userSelectedListArr = this.state.userSelectedList;
           userSelectedListArr.push(tag);
           this.setState({
              userSelectedList:userSelectedListArr
            });
           //console.log(userSelectedListArr,'userSelectedListArr===')
            setTimeout(() => {
              this.updateNotifyUsers();
            }, 1000);
        }
    }
    //UPDATE/ADD SELECTED VALUES ID ONCE ADDED
    updateNotifyUsers = ()=>{
      const {userSelectedList} = this.state; 
      const {actionChangeHandler} = this.props;
      let selectedValue =[];
      //console.log(userSelectedList,' updateNotifyUsers userSelectedList')
       userSelectedList.map((item)=>{
        selectedValue.push({
          value:item.value
        });
      });
       //console.log(selectedValue,'updateNotifyUsers selectedValue')
      actionChangeHandler({},'notified_users',selectedValue);
    }
    //DRAG AND SORT SELECTED/ADDED LOOKUP VALUES
    handleDrag(tag, currPos, newPos) {
        // const tags = [...this.state.tags];
        // const newTags = tags.slice();
        // newTags.splice(currPos, 1);
        // newTags.splice(newPos, 0, tag);
        // this.setState({ tags: newTags });
    }

    //HANDLER CLICK
    handleTagClick(index,actionType) {
        console.log(index,actionType);
        if(actionType==='click'){
            console.log('The tag at index ' + index + ' was clicked');
        }else if(actionType==='doubleclick'){
            // console.log(this.state.tags[index]);
            // this.setState({activeIndex:index,activeTag:this.state.tags[index]});
            // var inputField = this.refs.customToogleAddTags;
            // inputField.click();
            console.log('The tag at index ' + index +' was double clicked');
        }
    }
    //SEARCHING AND LIST VALUES FROM LIST ON KEYUP
    handleInputChange = (suggestion)=>{
        this.fetchUserList(suggestion);
    }
    autoCompleteSelect = (obj) =>{
      const {actionChangeHandler} = this.props;
      actionChangeHandler({},'email_template_id',obj.id);
      let val = obj && Object.keys(obj).length === 0 ? '' : (obj.label || obj.text || '');
      this.setState({selectedTemplate:val});
      }
      autoCompleteSearch = (value) =>{
        this.setState({autoTemplateSearch:value});
        this.fetchEmailTemplateList(value);
      }
    fetchEmailConfigList = ()=>{
      let APIURL = 'email/config/search?smtp_active=true';
        callGET(APIURL)                                     
        .then(res => {
            if(res.status===200){ 
                const response = res.data;
                if(response.code===200){
                    if(response.data!==null){
                      let emailConfigList = response.data.map((item,index)=>{
                        return{
                          label:item.user_name,
                          id:item.id,
                          value:item.user_name,
                        }
                      });
                      this.setState({emailConfigList:[{label:'-None-',id:'',value:'-None-'},...emailConfigList]});
                    }
                }
            }
        },(error) => {
            console.log(error);
        })
    }

  
  fetchEmailTemplateList = (value)=>{
    const params = this.props.match.params;
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    const perPage = 20;//pagination.perPage; 
    const direction = '';//pagination.direction; 
    const search = value;//pagination.search;
  
    const queryString = '';//&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&sortAsc='+direction+'search='+search;
    const API_Url = 'email/template/search?window_id='+params.windowId+queryString;
    callGET(API_Url) 
        .then(res => {
          if(res.status===200){ 
            const response = res.data;
            if(response.code===200 && response.data!==undefined){
              const responseData = response.data;
              let tableData  = responseData.content.map((item)=>{
                return{
                    label:item.name,
                    value:item.id,
                    id:item.id,
                    text:item.name,
                  }
              });
              console.log('tableData',tableData);
              this.setState({
                emailTemplateList:tableData
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          //this.props.Loader();
        })
    }
}
export default EmailOptions;

